import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

export enum DatasheetFormatManagementMode {
  export = "export",
  load = "load",
  new = "new",
}

export type DatasheetFormatManagementSubmitExportParams = {
  format: { id: number; name: string };
  folder: FolderPrimaryListDto;
};

export type DatasheetFormatManagementSubmitImportParams = {};

export type DatasheetFormatManagementSubmitLoadParams = {};

export type DatasheetFormatManagementSubmitNewParams = {};

export type DatasheetFormatManagementSubmitParams =
  | DatasheetFormatManagementSubmitExportParams
  | DatasheetFormatManagementSubmitImportParams
  | DatasheetFormatManagementSubmitLoadParams
  | DatasheetFormatManagementSubmitNewParams;

export type DatasheetFormatManagementProps = {
  onClose: () => void;
  getId: {
    title: string;
    folderChooserBtn?: string;
    selectedFolderNameHolder?: string;
    formatTypes: string;
    formatName?: string;
  };
  getFormats: (folderId: number) => Promise<Array<DatasheetFormatManagementFormat>>;
  onSubmit: (params: DatasheetFormatManagementSubmitParams) => void;
  getFolders: () => Promise<Array<FolderPrimaryListDto>>;
  checkFormatNameExists: () => Promise<boolean>;
  isAllowedToSubmit?: (params: {
    folderId?: FolderPrimaryListDto["id"];
    formatId?: DatasheetFormatManagementFormat["id"];
    newFormatName?: string;
  }) => boolean;
  mode: DatasheetFormatManagementMode;
  isAllowedToSubmitFormatManagementSubmit?: (params: {
    folderId?: FolderPrimaryListDto["id"];
    formatId?: DatasheetFormatManagementFormat["id"];
    newFormatName?: string;
  }) => boolean;
};

export type DatasheetFormatManagementFormat = {
  id: number;
  name: string;
};

export type DatasheetFormatManagementConfig = {
  title: string;
  submitBtnText: string;
  isAllowedToSubmit: (params: {
    folderId?: FolderPrimaryListDto["id"];
    formatId?: DatasheetFormatManagementFormat["id"];
    newFormatName?: string;
  }) => boolean;
  showFormatName?: boolean;
  formatManagement: {
    title: string;
    isAllowedSubmit: ({ formatId }: { formatId: number }) => boolean;
    submitBtnProps: {
      text: string;
    };
    deleteFormatBtnProps?: {
      text: string;
    };
    handleFormatDelete?: (folderId: number, formatId: number) => Promise<void>;
    handleFolderDelete?: (folderId: number) => Promise<void>;
    handleFolderCreate?: (data: { parentId?: number; name: string }) => Promise<void>;
  };
};
